function FormikError({
  formik,
  name,
  marginTopClass,
}: {
  formik: any;
  name: string;
  marginTopClass?: string;
}) {
  return !!formik ? (
    formik.touched[name] && formik.errors[name] ? (
      <p className={`help text-xs ${marginTopClass || "mt-8"} flex text-12 text-error`}>
        {typeof formik.errors[name] !== "object"
          ? formik.errors[name]
          : formik.errors[name][Object.keys(formik.errors[name])[0]]}
      </p>
    ) : null
  ) : null;
}

export default FormikError;
